import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "e72161d1-bd67-46d4-9f1a-ee7ea3db2070",
  solutionType: "custom012100",
  type: "custom012100",
  options: {
    targetPointLocation: [1, 1],
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom012100",
  data: {
    indexes: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
    ],
  },
};
